import { render, staticRenderFns } from "./MaximumValueRating.vue?vue&type=template&id=483127e1"
import script from "./MaximumValueRating.vue?vue&type=script&lang=js"
export * from "./MaximumValueRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports